import Icon from '../components/Icon.vue'

Icon.register({
  rainbow: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M268.3 32.7c167.7-11.3 307.7 122 307.7 287.3v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-136.2c0-113.8-81.6-215.4-194.5-229.9-136.6-17.6-253.5 88.9-253.5 222.1v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-133.8c0-153.3 115.4-287.3 268.3-297.5zM262.7 129.6c117.1-15 217.3 76.2 217.3 190.4v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-138.3c0-66.9-48.7-126.6-115.2-133.1-76.3-7.4-140.8 52.6-140.8 127.4v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-137.3c0-97.6 70-184.7 166.7-197.1zM268.9 225.9c61.3-11.9 115.1 34.9 115.1 94.1v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-144c0-17.6-14.3-32-32-32s-32 14.4-32 32v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-140.2c0-46.4 31.3-89 76.9-97.9z'
      }
    ]
  }
})
